__turbopack_context__.v({
  "content": "Accordion-module-scss-module__Mgz2YG__content",
  "fade-in": "Accordion-module-scss-module__Mgz2YG__fade-in",
  "icon": "Accordion-module-scss-module__Mgz2YG__icon",
  "iconButton": "Accordion-module-scss-module__Mgz2YG__iconButton",
  "isOpen": "Accordion-module-scss-module__Mgz2YG__isOpen",
  "label": "Accordion-module-scss-module__Mgz2YG__label",
  "root": "Accordion-module-scss-module__Mgz2YG__root",
  "theme--faq": "Accordion-module-scss-module__Mgz2YG__theme--faq",
  "theme--makers-reserve": "Accordion-module-scss-module__Mgz2YG__theme--makers-reserve",
  "toggle": "Accordion-module-scss-module__Mgz2YG__toggle",
});
